module.exports = require("util");


/*****************
 ** WEBPACK FOOTER
 ** external "util"
 ** module id = 350
 ** module chunks = 0
 **/